import React, { Fragment } from "react";
import {
  Form,
  Button,
  Loader,
  Card,
  Row,
  AccountNav,
  ViewContext,
  useAPI,
  Grid,
} from "components/lib";
const Axios = require("axios");

export function AdverseMediaView(props) {
  const accountInfo = useAPI("/api/account");
  const context = React.useContext(ViewContext);
  const [adverseMediaEnabled, setAdverseMediaEnabled] = React.useState(
    accountInfo?.data?.adverse_media_enabled
  );

  React.useEffect(() => {
    console.log("Adverse Media enabled: ", accountInfo?.data?.adverse_media_enabled);
    if (accountInfo?.data?.adverse_media_enabled) {
      setAdverseMediaEnabled(true);
    }
    else {
      setAdverseMediaEnabled(false);
    }
  }, [accountInfo?.data?.adverse_media_enabled]);

  if (!accountInfo.data) {
    return <Loader />;
  }

  const toggleAdverseMedia = async () => {
    await Axios.post("/api/account/adverse-media", {
      adverse_media_enabled: !adverseMediaEnabled,
    });

    setAdverseMediaEnabled(!adverseMediaEnabled);

    context.notification.show(
      `Adverse media ${!adverseMediaEnabled ? "enabled" : "disabled"}`,
      "success",
      true,
      "toast",
      `${!adverseMediaEnabled ? "check" : "x"}`
    ); 
  };

  return (
    <Fragment>
      <AccountNav />
      <Grid>
        <Row>
          <h1>Toggle Adverse Media</h1>
          <p className="text-xs leading-6">
            Current Status:{" "}
            {adverseMediaEnabled ? "Enabled" : "Disabled"}
            <Button text="Toggle" small action={toggleAdverseMedia}></Button>
          </p>
          <p className="text-xs leading-6">
            Please note, there are additional charges for adverse media. By clicking Save you are acknowledging this additional
            charge. Please to your Account Manager for more details.
          </p>
        </Row>
      </Grid>
    </Fragment>
  );
}

// To Dos
// Enable Sanctions
// Y/N
// Save to account
// toggle state to active
// Select sources
// Render a form
// single ofac checkbox
// Fix backend
// update backend to use the data in accout info on checks
